import TYPES from '../../types';

// Domain
import { CurrencyTypeEntity } from '../../domain/entities/currency-type-entity';
import { SearchCurrencyTypesRepository } from '../../domain/repositories/search-currency-types-repository';
import { CurrencyTypeStateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchCurrencyTypesQuery extends Query<Promise<Array<CurrencyTypeEntity>>> {
  @Inject(TYPES.CURRENCY_TYPES_STATE_MANAGER)
  private readonly state_manager!: CurrencyTypeStateManager;

  @Inject(TYPES.SEARCH_CURRENCY_TYPES_REPOSITORY)
  private readonly repository!: SearchCurrencyTypesRepository;

  internalExecute(): Promise<Array<CurrencyTypeEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.items.length) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
